import * as React from 'react';
import { Button, Empty, Popconfirm, Table } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { useNavigate, useParams } from 'react-router-dom';
import { useCampaignReports, useDeleteReport } from '../queryHooks';
import { formatDateRange } from '../format';
import ReportWizard from './ReportWizard';

const ReportsList: React.FC = () => {
    const { id } = useParams<{ id: string }>();
    const campaignId = id ? Number(id) : undefined;
    const navigate = useNavigate();
    const { data: reports = [], isLoading } = useCampaignReports(campaignId);
    const del = useDeleteReport();
    const [open, setOpen] = React.useState(false);

    return (
        <div>
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 12 }}>
                <Button type="primary" icon={<PlusOutlined />} onClick={() => setOpen(true)}>New report</Button>
            </div>
            <Table
                rowKey="id"
                loading={isLoading}
                dataSource={reports}
                pagination={false}
                locale={{ emptyText: <Empty description="No reports yet" /> }}
                onRow={(row) => ({
                    onClick: () => navigate(`/creators/campaigns/${campaignId}/reports/${row.id}`),
                    style: { cursor: 'pointer' },
                })}
                columns={[
                    { title: 'Name', dataIndex: 'name' },
                    {
                        title: 'Date range',
                        render: (_, row) => formatDateRange(row.start_date, row.end_date) || 'Campaign dates',
                    },
                    {
                        title: 'Updated',
                        dataIndex: 'updated_at',
                        render: (v: string) => v ? new Date(v).toLocaleString() : '—',
                    },
                    {
                        title: '',
                        width: 80,
                        render: (_, row) => (
                            <Popconfirm
                                title="Delete this report?"
                                onConfirm={(e) => {
                                    e?.stopPropagation();
                                    if (campaignId && row.id) del.mutate({ campaignId, reportId: row.id });
                                }}
                            >
                                <Button type="link" danger size="small" onClick={(e) => e.stopPropagation()}>Delete</Button>
                            </Popconfirm>
                        ),
                    },
                ]}
            />
            <ReportWizard
                open={open}
                campaignId={campaignId}
                onCancel={() => setOpen(false)}
                onCreated={(reportId) => {
                    setOpen(false);
                    navigate(`/creators/campaigns/${campaignId}/reports/${reportId}`);
                }}
            />
        </div>
    );
};

export default ReportsList;
